module.exports = __webpack_public_path__ + "img/mail.08f16f8d.svg";